import { ApplicationState } from '@/platform/ApplicationState';
import { Visa } from '@/presenters/Visa';
import { IMutations } from './IMutations';
import { IState } from './IState';

export class Mutations implements IMutations {
	private readonly state: IState;

	public constructor(state: IState) {
		this.state = state;
	}

	public setApplicationState(applicationState: ApplicationState): void {
		this.state.applicationState = applicationState;
	}

	public setOriginCountryId(originCountryId: string | null): void {
		this.state.originCountryId = originCountryId;
	}

	public setDestinationCountryId(destinationCountryId: string | null): void {
		this.state.destinationCountryId = destinationCountryId;
	}

	public setVisa(visa: Visa | null): void {
		this.state.visa = visa;
	}
}
